/**
 * Human form of how long a review has waited with its assignee (ENG-27734):
 * "< 1 min", "45 min", "3 h", "2 d 4 h". Prefers the server's assigned_at so
 * the value stays fresh while the page is open; falls back to the server's
 * waiting_seconds when the timestamp is unreadable.
 */
export function formatWaiting(
  assignedAt: string | undefined,
  waitingSeconds: number | undefined,
  now: number = Date.now(),
): string {
  let seconds: number | null = null;
  if (assignedAt) {
    const t = Date.parse(assignedAt);
    if (!Number.isNaN(t)) seconds = Math.floor((now - t) / 1000);
  }
  if (seconds === null && typeof waitingSeconds === "number") {
    seconds = waitingSeconds;
  }
  if (seconds === null || !Number.isFinite(seconds)) return "—";
  seconds = Math.max(0, seconds);
  if (seconds < 60) return "< 1 min";
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} h`;
  const days = Math.floor(hours / 24);
  const restHours = hours % 24;
  return restHours === 0 ? `${days} d` : `${days} d ${restHours} h`;
}
